import "./Investors.module.css";
import Header from "@/reusable_sections/Header";
import InvestmentAcquisition from "./sections/InvestmentAcquisition";
import PerformanceReporting from "./sections/PerformanceReporting";
import InvestKcFooter from "@/reusable_sections/Footer";
export default function InvestorsPage() {
  return <div>
      <Header />
      <InvestmentAcquisition />
      <PerformanceReporting />
      <InvestKcFooter />
    </div>;
}